import { t as __t } from "i18next";
import React, { useState, useEffect, useRef } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch } from "react-redux";
import { callCustomerById, callPostCustomer, callPostAddCustomer } from "../../../api/callcenters/service"
import { callGetAllProvince, callGetDistrict, callUploadFile } from "../../../api/settings/service"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import "../../../components/i18n/lang";
import { decodeBase64, handleGetCookie, displayUrl, convertStringToJson } from "../../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import colors from '../../../utils/colors'
import moment from "moment";
import documentType from "../../../data/documentType"
import FileUploadGrid from "../../../components/upload-file";

const Index = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [dateOfBirth, setDateOfBirth] = useState(null);
	const [issueDate, setIssueDate] = useState(null);
	const [expiredDate, setExpiredDate] = useState(null);
	const [customer, setCustomers] = useState({
		firstName: '', lastName: '', gender: 'm', phone: '', dateOfBirth: '', provinceId: '', districtId: '',
		village: '', documentType: '', documentNo: '', issueDate: '', issuePlace: '', expiredDate: '', modifiedDate: '',
		modifiedBy: '', isVerify: 0, documentImagePath: null, id: 0, carriredName: '', homeNumber: '', unitNumber: '',
		oldVerify: 0
	});
	const [selectedFile, setSelectedFile] = useState(null);
	const fileInputRef = useRef(null);
	const [provinceList, setProvinceList] = useState([]);
	const [districtList, setDistrictList] = useState([]);
	let params = useParams();

	useEffect(() => {
		loadProvince()

		if (Object.keys(params).length > 0) {
			let id = decodeBase64(params?.id)
			if (id != null) {
				setCustomers((prev) => ({
					...prev, id
				}));
				intialData(id)
			}
		}
		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setCustomers((prev) => ({
				...prev,
				carriredCode: authData?.user?.userId,
				carriredName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
			}));
		}
	}, []);

	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}

	}

	const intialData = async (id) => {
		const res = await dispatch(callCustomerById({ customerId: id }))
		if (res?.payload?.responseCode === "00000") {
			let data = res?.payload?.data
			loadDistrict(data?.provinceId);

			setCustomers((prev) => ({
				...prev,
				id,
				firstName: data?.firstName,
				lastName: data?.lastName,
				gender: data?.gender,
				phone: data?.phone,
				dateOfBirth: moment(data?.dateOfBirth).format("YYYY-MM-DD"),
				documentNo: data?.documentNo,
				documentType: data?.documentTypeId,
				documentImagePath: data?.documentImagePath ? convertStringToJson(data?.documentImagePath) : '',
				village: data?.village,
				issueDate: data?.issueDate,
				issuePlace: data?.issuePlace || '',
				expiredDate: data?.expiredDate,
				provinceId: data?.provinceId,
				districtId: data?.districtId,
				isVerify: data?.isVerify,
				homeNumber: data?.homeNumber,
				unitNumber: data?.unitNumber,
				oldVerify: data?.isVerify,
			}));

			setDateOfBirth(moment(data?.dateOfBirth).format("YYYY-MM-DD"))
			setIssueDate(data?.issueDate != null ? moment(data?.issueDate).format("YYYY-MM-DD") : null)
			setExpiredDate(data?.expiredDate != null ? moment(data?.expiredDate).format("YYYY-MM-DD") : null)

		}
	}

	const handleChange = (e) => {
		const { name, value } = e.target;
		setCustomers({
			...customer,
			[name]: value,
		});
	};

	const selectedProvince = async (e) => {
		e.preventDefault();
		setCustomers((prev) => ({
			...prev,
			provinceId: e.target.value
		}));

		loadDistrict(e.target.value)
	}

	const selectedDistrict = (e) => {
		e.preventDefault();
		setCustomers((prev) => ({
			...prev,
			districtId: e.target.value
		}));
	}

	const loadDistrict = async (proId) => {
		const rs = await dispatch(callGetDistrict({ provinceId: proId }));
		if (rs?.payload?.responseCode === "00000") {
			setDistrictList(rs?.payload?.data)
		}
	}

	const selectedDocument = (e) => {
		e.preventDefault();
		setCustomers((prev) => ({
			...prev,
			documentType: e.target.value
		}));
	}

	const handleSave = async (e) => {
		e.preventDefault()
		try {
			Swal.fire({
				name: t("nameSave"),
				text: t("confirmSave"),
				icon: "warning",
				reverseButtons: true,
				showCancelButton: true,
				confirmButtonColor: colors.confirmMessage,
				cancelButtonColor: colors.cancel,
				confirmButtonText: t('confirm'),
				cancelButtonText: t('cancel')
			}).then(async (result) => {
				if (result.isConfirmed) {
					try {

						let docPath = null
						if (selectedFile !== null) {
							const upload = await dispatch(callUploadFile(selectedFile.file));
							if (upload?.payload?.responseCode === "00000") {
								docPath = JSON.stringify(upload?.payload?.data)
							}
						} else {
							docPath = customer.documentImagePath
						}

						let req = {
							customerId: customer.id,
							firstName: customer.firstName,
							lastName: customer.lastName,
							gender: customer.gender,
							dateOfBirth: dateOfBirth,
							age: calculateAge(moment(dateOfBirth).format("YYYY-MM-DD")),
							documentTypeId: customer.documentType ?? null,
							documentNo: customer.documentNo,
							documentImagePath: docPath,
							issueDate: (issueDate != null ? moment(issueDate).format("YYYY-MM-DD") : null),
							expiredDate: (expiredDate != null ? moment(expiredDate).format("YYYY-MM-DD") : null),
							issuePlace: customer.issuePlace,
							homeNumber: customer.homeNumber,
							unitNumber: customer.unitNumber,
							phone: customer.phone,
							provinceId: customer.provinceId,
							districtId: customer.districtId,
							village: customer.village,
							updatedBy: customer.carriredName,
							isVerify: customer.isVerify
						}

						let res = null;
						if (customer.id > 0) {
							res = await dispatch(callPostCustomer(req));
						} else {
							res = await dispatch(callPostAddCustomer(req));
						}

						if (res?.payload?.responseCode === "00000") {
							Swal.fire({
								icon: "success",
								title: t("success.add"),
								confirmButtonColor: colors.confirmMessage,
								confirmButtonText: t('close'),
							}).then(function () {
								notifyListRefresh();
								navigate(-1);
							});
						} else {
							Swal.fire(__t("uiText.text023"), res?.payload?.responseCode + " - " + res?.payload?.responseDescription, "error");
						}
					} catch (error) {
						Swal.fire(__t("uiText.text023"), __t("uiText.text024"), "error");
					}
				}
			});
		} catch (error) {
			console.error("error: ", error)
		}
	}

	const calculateAge = (dateOfBirth) => {
		if (!dateOfBirth) return null;

		const birthDate = new Date(dateOfBirth);
		const today = new Date();

		let age = today.getFullYear() - birthDate.getFullYear();

		const hasHadBirthdayThisYear =
			today.getMonth() > birthDate.getMonth() ||
			(today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

		if (!hasHadBirthdayThisYear) {
			age--;
		}

		return age;
	};

	const triggerFileInput = () => {
		fileInputRef.current.click();
	};

	const cancelSeletedFile = () => {
		setSelectedFile(null);
		if (customer.documentImagePath !== null) {
			setCustomers((prev) => ({
				...prev,
				documentImagePath: null,
			}));
		}
	};


	const handleImageSelect = (e) => {
		// const file = e.target.files[0];
		// if (file) {
		// 	const imageUrl = URL.createObjectURL(file);
		setSelectedFile({ file: e });
		// }
		// e.target.value = '';
	};



	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box back-title-group">
							<BackPrevious />
							<h4>{Object.keys(params).length > 0 ? t("callcenter.customerService.edit") : t("callcenter.customerService.add")}</h4>
						</div>

						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">
										<div className="row">
											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.id')}<span className="text-danger">*</span></label>
												<input
													type="number"
													className="form-control-uld"
													placeholder={t('callcenter.customerService.id')}
													value={customer.id}
													readOnly />
											</div>

											<div className="col-md-3 form-group">
												<label> {t('callcenter.customerService.firstName')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="firstName"
													className="form-control-uld"
													placeholder={t('callcenter.customerService.firstName')}
													onChange={handleChange}
													value={customer.firstName}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-3 form-group">
												<label> {t('callcenter.customerService.lastName')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="lastName"
													className="form-control-uld"
													placeholder={t('callcenter.customerService.lastName')}
													onChange={handleChange}
													value={customer.lastName}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.dateOfBirth')}<span className="text-danger">*</span></label>
												<DatePicker
													selected={dateOfBirth}
													onChange={date => setDateOfBirth(moment(date).format('YYYY-MM-DD'))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('callcenter.customerService.dateOfBirth')}
													className="form-control-uld"
													maxDate={new Date()}
													required
												/>
											</div>

											<div className="col-md-2 form-group">
												<label>{t('callcenter.customerService.gender')}</label>
												<select className="chosen-single form-select"
													name="gender"
													onChange={handleChange}
													value={customer.gender}
													required
												>
													<option key={"m"} value={"m"}>{t("gender.m")}</option>
													<option key={"f"} value={"f"}>{t("gender.f")}</option>
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.phone')} <span className="text-danger">*</span> </label>
												<input
													type="number"
													name="phone"
													className="form-control-uld"
													placeholder={t('callcenter.customerService.phone')}
													onChange={handleChange}
													value={customer.phone}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.provinceName')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="provinceName"
													onChange={selectedProvince}
													value={customer.provinceId}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														provinceList.map((item) => (
															<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.districtName')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="districtName"
													onChange={selectedDistrict}
													value={customer.districtId}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														districtList.map((item) => (
															<option key={item.districtId} value={item.districtId}>{item.districtName}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.village')} <span className="text-danger">*</span> </label>
												<input
													type="text"
													name="village"
													className="form-control-uld"
													placeholder={t('callcenter.customerService.village')}
													onChange={handleChange}
													value={customer.village}
													autoComplete="off" />
											</div>

											<div className="col-md-2 form-group">
												<label>{t('callcenter.customerService.documentType')}<span className="text-danger">*</span></label>
												<select className="chosen-single form-select"
													name="documentType"
													onChange={selectedDocument}
													value={customer.documentType}
												>
													<option key={0} value={""}>{t("selectedAll")}</option>
													{
														documentType.map((item) => (
															<option key={item.id} value={item.id}>{t(item.name)}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.documentNo')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="documentNo"
													className="form-control-uld"
													placeholder={t('callcenter.customerService.documentNo')}
													onChange={handleChange}
													value={customer.documentNo}
													autoComplete="off"
													required
												/>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.homeNumber')}</label>
												<input
													type="number"
													name="homeNumber"
													className="form-control-uld"
													placeholder={t('callcenter.customerService.homeNumber')}
													onChange={handleChange}
													value={customer.homeNumber}
													autoComplete="off"
												/>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.unitNumber')} </label>
												<input
													type="number"
													name="unitNumber"
													className="form-control-uld"
													placeholder={t('callcenter.customerService.unitNumber')}
													onChange={handleChange}
													value={customer.unitNumber}
													autoComplete="off"
												/>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.issueDate')}</label>
												<DatePicker
													selected={issueDate}
													onChange={date => setIssueDate(moment(date).format('YYYY-MM-DD'))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('callcenter.customerService.issueDate')}
													className="form-control-uld"
													maxDate={new Date()}
												/>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.issuePlace')}</label>
												<input
													type="text"
													name="issuePlace"
													className="form-control-uld"
													placeholder={t('callcenter.customerService.issuePlace')}
													onChange={handleChange}
													value={customer.issuePlace}
													autoComplete="off" />
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.customerService.expiredDate')}</label>
												<DatePicker
													selected={expiredDate}
													onChange={date => setExpiredDate(moment(date).format('YYYY-MM-DD'))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('callcenter.customerService.expiredDate')}
													className="form-control-uld"
												/>
											</div>

											<div className="col-md-2 form-group">
												<label>{t('callcenter.customerService.isVerify')}<span className="text-danger">*</span></label>
												<select className="chosen-single form-select"
													name="isVerify"
													onChange={handleChange}
													value={customer.isVerify}
													disabled={customer.oldVerify === 1}
													style={customer.oldVerify === 1 ? { color: colors.primary } : {}}
												>
													<option key={0} value={0}>{t("verifyStatus.notVerify")}</option>
													<option key={1} value={1}>{t("verifyStatus.verify")}</option>
												</select>
											</div>

											<div className="col-12 col-md-12 form-group">
												<label> {t('settings.agentSpecialCommission.documentReference')} <span className="text-danger">*</span> </label>
												<FileUploadGrid
													multiple={true}
													folderName="customers"
													filesFromApi={customer.documentImagePath || []}
													onChange={handleImageSelect}
													accept="image/*,application/pdf"
													required

												/>
											</div>

											<div className="col-12 d-flex justify-content-center">
												<div className="m-3">
													<button className="theme-btn btn-style-one w-100" type="submit">
														<i className="fas fa-add"></i>&nbsp;{t("button.save")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
